import { render } from "./PageDataSourcePopover.vue?vue&type=template&id=5f0cb316"
import script from "./PageDataSourcePopover.vue?vue&type=script&lang=js"
export * from "./PageDataSourcePopover.vue?vue&type=script&lang=js"

import "./PageDataSourcePopover.vue?vue&type=style&index=0&id=5f0cb316&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__